import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

import * as StringTools from "~/utilities/string"
import * as PhoneNumberTools from "~/utilities/phoneNumber"
import SimpleInput from "~/components/Form/SimpleInput"
import InputItemWrapper from "~/components/Form/InputItemWrapper"
import NotchedField from "~/components/parking/_design/NotchedField"
import AmericanFlagIcon from "~/public/static/images/svg/flag.svg"

const INPUT_FIELD_KEY = "phoneNumber"

const Wrapper = styled.div`
  display: flex;
  border-radius: 8px;
  transition: all 500ms ease;
  border: ${props => props.noBorder? "none" : "1px solid "} ${props =>
    props.error
    ? props.theme.colors.error
    : "#d7d7e0"};
`

const FlagBox = styled.div`
  border-right: 1px solid #d8d8d8;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px 8px;
`

@inject(all => ({
  user: all.store.auth.user
}))
@observer
class PhoneNumber extends Component {
  handleChange = event => {
    const rawInput = event.target.value
    const digitInput = StringTools.removeNonDigits(rawInput)
    this.props.user.changeKey(INPUT_FIELD_KEY, digitInput)
  }

  render() {
    const { disabled, user, notched } = this.props
    const errorMessage = user.validateDisplayMessage(INPUT_FIELD_KEY)

    if (notched) {
      return (
        <NotchedField label="Phone Number" error={errorMessage}>
          <div style={{ display: "flex", alignItems: "center", height: "100%", width: "100%" }}>
            <FlagBox>
              <img src={AmericanFlagIcon} alt="American Flag Icon" />
            </FlagBox>
            <div style={{ flex: 1, minWidth: 0 }}>
              <SimpleInput
                id="phoneNumber"
                type="tel"
                value={PhoneNumberTools.AsYouTypeFormatter(user[INPUT_FIELD_KEY])}
                onChange={this.handleChange}
                disabled={disabled}
                placeholder="(646) 855-8787"
                noBorder
                backgroundColor="transparent"
                maxLength={16} // 1 (234) 567-8900
                height="48px"
                textIndent="10px"
              />
            </div>
          </div>
        </NotchedField>
      )
    }

    return (
      <InputItemWrapper label="Phone Number" error={errorMessage}>
        <Wrapper error={errorMessage}>
          <FlagBox>
            <img src={AmericanFlagIcon} alt="American Flag Icon" />
          </FlagBox>
          <SimpleInput
            id="phoneNumber"
            type="tel"
            value={PhoneNumberTools.AsYouTypeFormatter(user[INPUT_FIELD_KEY])}
            onChange={this.handleChange}
            disabled={disabled}
            placeholder="(646) 855-8787"
            noBorder
            maxLength={16} // 1 (234) 567-8900
            height="48px"
          />
        </Wrapper>
      </InputItemWrapper>
    )
  }
}

export default PhoneNumber
